module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.7@core-js/library/modules/_add-to-unscopables.js
// module id = 416
// module chunks = 0 1